<template>
	<b-carousel
		indicators
		background="rgb(171, 171, 171)"
		:interval="4000"
		v-model="slide"
		@sliding-start="onSlideStart"
		@sliding-end="onSlideEnd"
	>
		<b-carousel-slide
			v-for="(url, index) in data"
			:key="index"
			:img-src="url"
		></b-carousel-slide>
	</b-carousel>
</template>

<script>
export default {
	name: "slider",
	data() {
		return {
			slide: 0,
			sliding: null,
		};
	},
	methods: {
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
	},
	props: {
		data: Array,
	},
	created() {
		console.log(this.data);
	},
};
</script>



// WEBPACK FOOTER //
// src/components/slider.vue